import { useContext } from 'react'
import { OptimizelyContext } from '../OptimizelyContext'
import { OptimizelyFeatureFlags, OptimizelyDecisionWithoutUserContext } from 'models/Optimizely'

export const useFeatureFlag = (
  flagName: OptimizelyFeatureFlags,
): OptimizelyDecisionWithoutUserContext => {
  const { featureFlags } = useContext(OptimizelyContext)

  return featureFlags[flagName] || { enabled: false }
}
